export const LINK_QUERY_PARAMS = { store: 'false' };
